import React from 'react'
import { VictoryPie, VictoryLabel, VictoryContainer } from 'victory'
import PropTypes from 'prop-types'

let getPercentageData = (percent) => ([{x: 1, y: percent}, {x: 2, y: 1 - percent}])

let PercentageGraph = ({value, radius, colors, ...rest}) => {
  let width = radius * 2
  let height = radius * 2
  return (
    <div style={{width, height}}  {...rest}>
      <VictoryContainer width={200} height={200} responsive={true}>
        <VictoryPie 
          padding={0}
          standalone={false}
          width={200} height={200}
          data={getPercentageData(value)}
          innerRadius={80}
          cornerRadius={12.5}
          labels={() => null}
          padAngle={1.5}
          colorScale={colors}
        />
        <VictoryLabel
          standalone={false}
          textAnchor="middle" verticalAnchor="middle"
          x={100} y={100}
          text={`${Math.round(value * 100)/100}%`}
          style={{ fontSize: 28, fill: colors[0] }}
          padAngle={1.5}
        />
      </VictoryContainer>
    </div>
  )}

PercentageGraph.propTypes = {
  value: PropTypes.number.isRequired,
  radius: PropTypes.number.isRequired,
  colors: PropTypes.array
}

export default PercentageGraph


// WEBPACK FOOTER //
// ./src/components/PercentageGraph.js